export default __webpack_public_path__ + "static/media/Twitter.265295b8.svg";